module.exports = __webpack_public_path__ + "packs/media/images/pic07-43baa0fd8f18f4b6dde2bd104545f800.jpg";